import { Injectable } from '@angular/core';
import { BoSpinnerService, BoToastrService } from 'src/@core/shared';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestOptions, Headers } from '@angular/http';
import { API } from '../config/api';
import { GetNewSuppierInvoice, GetConsigment } from '.';
import { tap, catchError } from 'rxjs/operators';
import { SUCCESS } from 'src/@shared/constants';
import { ErrorResponse } from '../config/common';
import * as moment from 'moment';
@Injectable()
export class NewSupplierInvoiceService {
    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
        private _toastr: BoToastrService,
        
    ) { 

    }

    // CRATE SUPPLIER INVOICE
    public CreateSupplierInvoice(model: GetNewSuppierInvoice){
        const formData = new FormData();
        formData.append('InvoicePDF', model.InvoicePDF);
        formData.append('SubcontractorID', model.SubcontractorID);
        formData.append('BranchID', model.BranchID);
        formData.append('DateReceived', moment(model.DateReceived).format());
        formData.append('InvoiceNumber', model.InvoiceNumber.toString());
        formData.append('InvoiceNewTotal', model.InvoiceNewTotal.toString());
        formData.append('PaymentTerms', model.PaymentTerms.toString());
        formData.append('InvoiceVatable', String(model.InvoiceVatable));
        formData.append('CheckPDF', String(model.CheckPDF));
        formData.append('Consignments', model.Consignments.join(','));
        formData.append('VATNumber', model.VATNumber);
        return this._http.post(API.NEW_SUPPLIER_INVOICE.CREATE, formData)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.NEW_SUPPLIER_INVOICE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }

    // LAY CONSIGMENT
    public GetAllConsigment(model: GetConsigment){
         this._spinner.show();
        return this._http.post(API.NEW_SUPPLIER_INVOICE.GET_CONSIGMENT, model)
        .pipe(
            tap(() => {
                 this._spinner.hide();
            }),
            catchError((err: ErrorResponse) => {
                this._toastr.errors(err.error.errors);
                throw err;
            })
        );
    }

    public ChangeSubContractorInvoiceAttachment(id: string, invoicePdf: any) {
        const formData = new FormData();
        formData.append('Id', id);
        formData.append('InvoicePDF', invoicePdf);
        return this._http.post(API.NEW_SUPPLIER_INVOICE.CHANGE_INVOICE_ATTACHMENT, formData);
    }
}